<template>
  <div>
   
      <b-card>
        <b-row>
          <b-col cols="1">
            <b-button size="md" @click="redirectToHome" variant="outline-primary"
              ><i class="fa-solid fa-house-chimney"></i
            ></b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12">
            <b-tabs pills card>
              <b-tab title="User Management" active>
                <b-card-text>
                  <UserUpload />
                </b-card-text>
              </b-tab>
              <b-tab title="Claim Management">
                <b-card-text>
                  <ClaimUpload />
                </b-card-text>
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
      </b-card>
 
  </div>
</template>

<script>
import Vuetable from "vuetable-2/src/components/Vuetable";
import UserUpload from "@/components/UserManagement/UserUpload.vue";
import ClaimUpload from "@/components/UserManagement/ClaimUpload.vue";
import mixins from "./../../mixins/common.js";

export default {
  components: {
    Vuetable,
    UserUpload,
    ClaimUpload,
  },
  mixins: [mixins],
  data() {
    return {};
  },
  mounted(){
    //clear snotofy 
    this.clearSnotifyMessages();
  }
};
</script>

<style scoped>
</style>